module.exports = __webpack_public_path__ + "static/media/click-06.afb97452.mp3";